import { useStoreContext } from '../CurrentStoreProvider'

const sanitizeWhatsAppPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/\D/g, '')
}

const useCloseStore = () => {
  const { data: store, isSuccess: loadedStore } = useStoreContext()

  const close = () => {
    if (!loadedStore) return

    const sanitized = sanitizeWhatsAppPhoneNumber(store.attributes.whatsapp_phone_number)

    window.location.replace(`https://wa.me/${sanitized}`)
    window.setTimeout(() => window.close(), 100)
  }

  return close
}

export default useCloseStore
